import React, { useState } from 'react';
import { Modal, Upload, Button, Spin, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useUploadProcessedFileMutation, useInspectFileMutation } from '../../../redux/api/compassPortal';
import FilePreview from '../FilePreview';

const ProcessedFileUploadModal = ({ open, onClose, source, projectId }) => {
    const [uploadProcessed, { isLoading: isUploading }] = useUploadProcessedFileMutation();
    const [inspectFile, { isLoading: isInspecting }] = useInspectFileMutation();
    const [selectedFile, setSelectedFile] = useState(null);
    const [inspection, setInspection] = useState(null);

    const handleFileChange = async (info) => {
        const file = info.fileList?.[0]?.originFileObj;
        if (!file) {
            setSelectedFile(null);
            setInspection(null);
            return;
        }
        setSelectedFile(file);
        try {
            const result = await inspectFile({ projectId, file }).unwrap();
            setInspection(result);
        } catch {
            setInspection(null);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) return;
        try {
            await uploadProcessed({ projectId, sourceId: source.source_id, file: selectedFile }).unwrap();
            message.success(`Processed file uploaded for "${source.name}"`);
            setSelectedFile(null);
            setInspection(null);
            onClose();
        } catch (err) {
            message.error('Failed to upload processed file');
            console.error('Processed upload failed:', err);
        }
    };

    if (!source) return null;

    return (
        <Modal
            title={`Upload Processed File — ${source.name}`}
            open={open}
            onOk={handleUpload}
            onCancel={() => { setSelectedFile(null); setInspection(null); onClose(); }}
            okText="Upload"
            okButtonProps={{ disabled: !selectedFile }}
            confirmLoading={isUploading}
            width={600}
            destroyOnClose
        >
            <p style={{ color: 'var(--medium-light-grey-color)', fontSize: 13, marginBottom: 16 }}>
                Upload the processed version of this data source. The original file will be kept separately.
            </p>

            {source.file_name && (
                <div style={{
                    padding: '8px 12px', marginBottom: 12,
                    background: 'var(--tertiary-color)',
                    border: '1px solid rgba(255,255,255,0.07)',
                    borderRadius: 6, fontSize: 13,
                }}>
                    Original file: <strong>{source.file_name}</strong>
                </div>
            )}

            <Upload
                beforeUpload={() => false}
                maxCount={1}
                onChange={handleFileChange}
                accept=".csv,.xlsx,.xls"
            >
                <Button icon={<UploadOutlined />}>Choose processed file...</Button>
            </Upload>

            {isInspecting && (
                <div style={{ textAlign: 'center', padding: 16 }}>
                    <Spin tip="Inspecting file..." />
                </div>
            )}
            <FilePreview inspection={inspection} />
        </Modal>
    );
};

export default ProcessedFileUploadModal;
